import React, { useEffect } from "react";
import "./RefundPolicy.css";

function RefundPolicy() {

  useEffect(() => {
    document.title = "Refund Policy - Embarque Services";
  }, []);

  return (
 <section className="refund-section">
  <div className="refund-container">

    {/* HEADER */}
    <div className="refund-header">

      <span>REFUND & CANCELLATION</span>
      <br></br><br></br><br></br>

      <h1>Refund Policy</h1>

      <p className="refund-date">
         Effective Date: 05 August 2026
      </p>

      <p className="refund-intro">
        This Refund Policy explains the cancellation and refund process
        applicable to home appliance repair and maintenance services
        provided by <strong>Embarque Services</strong>. Refund eligibility
        depends on the status of the service, work completed, and any
        spare parts supplied or installed.
      </p>

    </div>


    {/* 1 */}
    <div className="refund-box">

      <h2>1. Service Cancellation</h2>

      <p>
        Customers may cancel or reschedule a service request before the
        scheduled service is carried out. Please contact us as early as
        possible if you need to cancel or change your appointment.
      </p>

    </div>


    {/* 2 */}
    <div className="refund-box">

      <h2>2. Technician Visit & Service Charge</h2>

      <p>
        Our basic service charge starts from <strong>₹400+</strong>.
        The applicable amount may vary depending on the appliance,
        service requirement, location, and work involved.
      </p>

      <p>
        Once the technician has reached the service location and carried
        out the applicable visit or inspection, the corresponding service
        or inspection charge is generally non-refundable.
      </p>

    </div>


    {/* 3 */}
    <div className="refund-box">

      <h2>3. Repair Charges</h2>

      <p>
        Payments for repair or maintenance work that has already been
        completed with the customer's approval are generally
        non-refundable.
      </p>

      <p>
        If you experience an issue relating to the work performed,
        please contact us with your service details. We will review the
        matter and determine the appropriate next step based on the
        circumstances.
      </p>

    </div>


    {/* 4 */}
    <div className="refund-box">

      <h2>4. Spare Parts</h2>

      <p>
        Spare-part costs are separate from the basic service charge.
        If a spare part needs to be replaced, the requirement and
        applicable cost will be communicated to the customer before
        replacement.
      </p>

      <p>
        Replacement work will proceed only after customer approval.
        Once an approved spare part has been supplied and installed,
        the amount paid for that part is generally non-refundable,
        subject to applicable warranty terms and consumer rights.
      </p>

    </div>


    {/* 5 */}
    <div className="refund-box">

      <h2>5. Eligible Refund Requests</h2>

      <p>
        A refund may be considered where payment has been received for
        a service or approved work that was not subsequently carried out,
        or where a refund is otherwise applicable based on the particular
        circumstances.
      </p>

      <p>
        Refund requests will be reviewed based on the service status,
        payment received, work completed, spare parts supplied or
        installed, and other relevant service information.
      </p>

    </div>


    {/* 6 */}
    <div className="refund-box">

      <h2>6. Non-Refundable Situations</h2>

      <p>
        Subject to applicable law, a refund may generally not be available
        in situations including:
      </p>

      <ul>
        <li>
          A technician visit or applicable inspection has already
          been completed.
        </li>

        <li>
          Customer-approved repair or maintenance work has already
          been completed.
        </li>

        <li>
          Customer-approved spare parts have already been supplied
          and installed.
        </li>

        <li>
          The reported issue is caused by a separate or pre-existing
          appliance fault unrelated to the work performed.
        </li>

        <li>
          Additional damage occurs after service due to misuse,
          external factors, or unauthorized repair or modification.
        </li>
      </ul>

    </div>


    {/* 7 */}
    <div className="refund-box">

      <h2>7. How to Request a Refund</h2>

      <p>
        To request a refund, please contact Embarque Services and provide
        sufficient information for us to identify and review your service.
        We may request:
      </p>

      <ul>
        <li>Customer name and registered phone number</li>
        <li>Service or appointment date</li>
        <li>Appliance and repair details</li>
        <li>Payment information or proof of payment, where applicable</li>
        <li>Reason for requesting the refund</li>
      </ul>

    </div>


    {/* 8 */}
    <div className="refund-box">

      <h2>8. Refund Processing</h2>

      <p>
        If a refund is approved, the approved amount and refund method
        will be communicated to the customer.
      </p>

      <p>
        Where appropriate, the refund may be processed through the
        original payment method. The time required for the amount to
        appear in your account may depend on your bank or payment
        service provider.
      </p>

    </div>


    {/* 9 */}
    <div className="refund-box">

      <h2>9. Independent Multi-Brand Service</h2>

      <p>
        <strong>Embarque Services</strong> is an independent multi-brand
        home appliance repair and maintenance service provider.
      </p>

      <p>
        Unless expressly stated otherwise, we are not an authorized or
        official service centre of any appliance manufacturer. Any
        third-party brand or product names used on our website are for
        identification purposes only.
      </p>

    </div>


    {/* 10 */}
    <div className="refund-box">

      <h2>10. Changes to This Policy</h2>

      <p>
        We may update this Refund Policy when our service procedures,
        payment practices, or applicable requirements change. Any revised
        policy will be published on this page with an updated effective
        date where appropriate.
      </p>

    </div>


    {/* 11 - CONTACT */}
    <div className="refund-box refund-contact-box">

      <h2>11. Contact Us</h2>

      <p>
        For cancellation, payment, or refund-related enquiries,
        please contact:
      </p>

      <div className="refund-contact-info">

        <p>
          <strong>Embarque Services</strong>
        </p>

        <p>
          <strong>Address:</strong>
          <br />
          90/48, Heera Nagar Thoppucolony,
          <br />
          Madurai,
          <br />
          Madurai South,
          <br />
          Tamil Nadu - 625001
        </p>

        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:embarque.ads@gmail.com">
            embarque.ads@gmail.com
          </a>
        </p>

        <p>
          <strong>Phone:</strong>{" "}
          <a href="tel:+919363929984">
            +91 93639 29984
          </a>
        </p>

      </div>

    </div>


    <p className="refund-footer">
      Please review this Refund Policy together with our Terms and
      Conditions and Privacy Policy before using our services.
    </p>

  </div>
</section>
  );
}

export default RefundPolicy;